import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FocusNotActivePictoProps extends pictoProps {
}

export interface FocusNotActivePictoState extends pictoState {
}

export class FocusNotActivePicto extends Picto<FocusNotActivePictoProps,FocusNotActivePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.focusNotActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FocusNotActivePicto);
